import { finish, error } from '../../../modules/customers/actions/set-wagering-limit';

import api from '../../../api';

export function request(dispatch, { id, data }) {
    api.patch(`/${id}/update-wagering-limits`, data).then(
        () => api.post(`/${id}/get-wagering-limits`).then(
            () => dispatch(finish(id, 'test'))
        ),
        ({ errors }) => dispatch(error(id, 'test', errors))
    );
}
